import { withStyles } from '@aura/components/styles'
import Grid from '@aura/components/grid'
import Link from '@aura/components/link'
import Typography from '@aura/components/typography'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import styles from './styles'


const Component = ({
    classes
}) => {

    const { t: translate } = useTranslation()

    return (<Grid className={classes.footerRoot}>
        <Grid className={classes.linkContainer}>
            <Link className={classes.link} href={translate('footer.privacylink')} underline="none" target="_blank" rel="noopener noreferrer">
                {translate('privacy')}
            </Link>
            <Link className={classes.link} href={translate('footer.legalDisclaimerLink')} underline="none" target="_blank" rel="noopener noreferrer">
                {translate('legalDisclaimer')}
            </Link>
            <Link className={classes.link} href={translate('footer.accessibilityLink')} underline="none" target="_blank" rel="noopener noreferrer">
                {translate('accessibility')}
            </Link>
        </Grid>
        <Grid className={classes.verbiageContainer}>
            <Typography className={classes.text}>{translate('footer.footerText')}</Typography>
        </Grid>
        <Grid className={classes.logoContainer}>
            <div className={classes.logo}>
                <img aria-labelledby="ciro logo" alt="ciro logo" src={translate('footer.ciroSrc')}/>
            </div>
        </Grid>
    </Grid>)
}
Component.propTypes = {
    classes: PropTypes.object.isRequired
}

export default withStyles(Component, styles)
